import React from 'react';
import { Link } from 'react-router-dom';
import { Twitter, Linkedin, Github } from 'lucide-react';
import { InnoverseLogo } from '../ui/InnoverseLogo';
import { products } from '../../data/products';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-slate-900 text-slate-400 py-16" data-id="element-22">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-23">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12" data-id="element-24">
          {/* Brand Column */}
          <div className="lg:col-span-2" data-id="element-25">
            <Link to="/" className="flex items-center space-x-2 mb-6 group" data-id="element-26">
              <InnoverseLogo size={32} variant="light" data-id="element-27" />
              <span className="text-xl font-bold text-white tracking-tight" data-id="element-28">
                Innoverse
              </span>
            </Link>
            <p className="text-slate-400 mb-6 max-w-sm leading-relaxed" data-id="element-29">
              Empowering small and medium businesses with enterprise-grade
              tools. One ecosystem for all your operational needs.
            </p>
            <div className="flex space-x-4" data-id="element-30">
              <a href="#" className="text-slate-400 hover:text-white transition-colors" data-id="element-31">
                <Twitter size={20} data-id="element-32" />
              </a>
              <a href="#" className="text-slate-400 hover:text-white transition-colors" data-id="element-33">
                <Linkedin size={20} data-id="element-34" />
              </a>
              <a href="#" className="text-slate-400 hover:text-white transition-colors" data-id="element-35">
                <Github size={20} data-id="element-36" />
              </a>
            </div>
          </div>

          {/* Links Columns */}
          <div data-id="element-37">
            <h3 className="text-white font-semibold mb-4" data-id="element-38">Products</h3>
            <ul className="space-y-3" data-id="element-39">
              {products.map(product => <li key={product.id} data-id="element-40">
                  <Link to={`/products/${product.id}`} className="hover:text-white transition-colors text-sm" data-id="element-41">
                    {product.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          <div data-id="element-42">
            <h3 className="text-white font-semibold mb-4" data-id="element-43">Company</h3>
            <ul className="space-y-3" data-id="element-44">
              <li data-id="element-45">
                <Link to="#" className="hover:text-white transition-colors text-sm" data-id="element-46">
                  About Us
                </Link>
              </li>
              <li data-id="element-47">
                <Link to="#" className="hover:text-white transition-colors text-sm" data-id="element-48">
                  Careers
                </Link>
              </li>
              <li data-id="element-49">
                <Link to="#" className="hover:text-white transition-colors text-sm" data-id="element-50">
                  Blog
                </Link>
              </li>
              <li data-id="element-51">
                <Link to="/contact" className="hover:text-white transition-colors text-sm" data-id="element-52">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-53">
            <h3 className="text-white font-semibold mb-4" data-id="element-54">Legal</h3>
            <ul className="space-y-3" data-id="element-55">
              <li data-id="element-56">
                <Link to="/privacy" className="hover:text-white transition-colors text-sm" data-id="element-57">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-58">
                <Link to="/terms" className="hover:text-white transition-colors text-sm" data-id="element-59">
                  Terms of Service
                </Link>
              </li>
              <li data-id="element-60">
                <Link to="#" className="hover:text-white transition-colors text-sm" data-id="element-61">
                  Cookie Policy
                </Link>
              </li>
              <li data-id="element-62">
                <Link to="#" className="hover:text-white transition-colors text-sm" data-id="element-63">
                  Security
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center text-sm" data-id="element-64">
          <p data-id="element-65">
            &copy; {currentYear} Innoverse Technologies Inc. All rights
            reserved.
          </p>
          <div className="mt-4 md:mt-0" data-id="element-66">
            <p data-id="element-67">Designed for modern businesses.</p>
          </div>
        </div>
      </div>
    </footer>;
}